<template>
  <section class="main">
    <TheHeader />
    <div class="container pt-4 pb-5">
      <div class="row">
        <div class="col">
          <h3>TELA TEMPORÁRIA DE ACEITE</h3>
          <hr />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <nav aria-label="breadcrumb" id="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">Aceite</li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="mt-4">
        <h4 class="h4 color-blue font-weight-bold">Aceite do Termo Aditivo</h4>
        <p class="mb-3">Algum texto referente a este aceite.</p>
        <Aceite
          :voltar="voltar"
          :link-voltar="linkVoltar"
          :link-aceite="linkAceite"
          :termo="termo"
          :aceite="aceite"
        />
      </div>
    </div>
  </section>
</template>
<script>
import TheHeader from "@/components/TheHeader.vue";
import Aceite from "@/components/aceite/Aceite.vue";
export default {
  name: "AceiteTeste",
  components: {
    TheHeader,
    Aceite,
  },
  data() {
    return {
      voltar: true,
      linkVoltar: "#",
      linkAceite: "#",
      aceite: "Aceito os termos...",
      termo: `Sed mollis, eros et ultrices tempus, mauris ipsum aliquam libero, non adipiscing dolor urna a orci. Aenean vulputate eleifend tellus. Donec posuere vulputate arcu. Proin viverra, ligula sit amet ultrices semper, ligula arcu tristique sapien, a accumsan nisi mauris ac eros. Donec posuere vulputate arcu.

Curabitur nisi. Nulla porta dolor. Phasellus accumsan cursus velit. Vivamus consectetuer hendrerit lacus. Nunc egestas, augue at pellentesque laoreet, felis eros vehicula leo, at malesuada velit leo quis pede.

Quisque rutrum. Praesent blandit laoreet nibh. Curabitur suscipit suscipit tellus. Nunc nec neque. Nunc nulla.

In consectetuer turpis ut velit. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Aliquam eu nunc. Etiam ut purus mattis mauris sodales aliquam. Sed a libero.

Ut tincidunt tincidunt erat. Suspendisse enim turpis, dictum sed, iaculis a, condimentum nec, nisi. In turpis. Etiam imperdiet imperdiet orci. Ut varius tincidunt libero.`,
    };
  },
};
</script>
